import { Component, Host, h, Prop, Element, State } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';


@Component({
  tag: 'banner-medium',
  styleUrl: 'banner-medium.css',
  shadow: true,
})
export class BannerMedium {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The super title
   */
  @Prop() superTitle: string;

  /**
   * The position title
   */
  @Prop() position: string;

  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Buttons Data
   */
  @Prop() buttonsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image alt
   */
  @Prop() imageAlt: string;

  /**
   * Image Url
   */
  @Prop() imageUrl: any;

  /**
   * Icon alt
   */
  @Prop() iconAlt: string;

  /**
   * Icon Url
   */
  @Prop() iconUrl: any;

  /**
   * Video
   */
  @Prop() videoUrl: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  /**
   * job banner flag
   */
  @Prop() jobBanner: string;

  @State() imageHeight: number;

  wordCountTrim(str, maxLength) {
    if (str.length <= maxLength) return str;

    // Attempt to find the last space before maxLength to avoid cutting a word
    const lastSpaceIndex = str.slice(0, maxLength + 1).lastIndexOf(' ');

    // If a space is found, and it's not the very first character, trim up to this space
    if (lastSpaceIndex > 0) return str.slice(0, lastSpaceIndex) + '...';

    // If no suitable space is found, or the only space is at the very start, return the original method
    return str.slice(0, maxLength) + (str.length > maxLength ? '...' : '');
  }

  @Element() el: HTMLElement;

  componentDidLoad() {
    // this.fetchImageHeight(this.imageUrl);

    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.banner-medium'),
      () => {
        this.el.shadowRoot.querySelector('.banner-medium').classList.add('animate');
      },
      ['.overlay1', '.overlay2'],
    );
  }
  // Watcher for imageUrl changes
  // @Watch('imageUrl')
  // imageUrlChanged(newValue: string, _oldValue: string) {
  //   this.fetchImageHeight(newValue);
  // }

  // async fetchImageHeight(url: string) {
  //   if (url) {
  //     const img = new Image();
  //     img.onload = () => {
  //       this.imageHeight = img.naturalHeight;
  //     };
  //     img.src = url;
  //   }
  // }
  render() {
    const buttons = JSON.parse(this.buttonsData);

    return (
      <Host>
        <div class={`container banner-medium-wrapper ${this.paddingBottom} ${this.paddingTop} ${this.jobBanner ? 'job-banner' : ''}`}>
          <div
            class={`banner-medium ${this.textColor} ${this.backgroundColor} ${this.backgroundImage ? 'aspect-video' : ''}`}
            style={{
              backgroundImage: `url(${this.backgroundImage})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
          >
            <div class={`overlay1`}></div>
            <div class="banner-medium-content relative">
              {this.iconUrl && <image-block imageUrl={this.iconUrl} imageAlt={this.iconAlt} imageClass={`banner-medium-icon`}></image-block>}
              {this.superTitle && <h2 class={`banner-medium-super-title fs-2`}>{this.superTitle}</h2>}
              {this.mainTitle && <h1 class={`banner-medium-title fs-5 font-semibold`}>{this.mainTitle}</h1>}
              {this.position && <h2 class={`banner-medium-position mt-12px md:mt-20px font-medium fs-2`}>{this.position}</h2>}
              {this.description && <div class={`banner-medium-description fs-2`} innerHTML={this.description}></div>}
              {buttons && buttons.length > 0 && (
                <div class="flex flex-wrap gap-12px mt-32px items-center">
                  {buttons.map(button => (
                    <button-block buttonsData={button}></button-block>
                  ))}
                </div>
              )}
            </div>
            <div class={`banner-medium-asset-wrapper relative ${this.assetType === 'video' && this.videoUrl && 'video-asset'} `}>
              {/* <div class={`overlay2`}></div> */}
              {this.assetType === 'image' && this.imageUrl && (
                <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt} imageClass={`banner-medium-asset aspect-square`}></image-block>
              )}
              {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl} videoLoop="true"></video-block>}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
